/** Persona context from GET /api/auth/me */
export interface AuthMePersona {
  email: string;
  isSupportUser: boolean;
  isAdmin: boolean;
  canAccessMonitoring: boolean;
  canAccessAnalytics: boolean;
}

export function isSupportPersona(persona: AuthMePersona | undefined): boolean {
  return persona?.isSupportUser === true;
}

export function isAdminPersona(persona: AuthMePersona | undefined): boolean {
  return persona?.isAdmin === true;
}

/** Customers, Promotions, and Customer Groups — Support users and administrators. */
export function canAccessSupportNavigation(persona: AuthMePersona | undefined): boolean {
  return isSupportPersona(persona) || isAdminPersona(persona);
}

export function canAccessMonitoring(persona: AuthMePersona | undefined): boolean {
  return persona?.canAccessMonitoring === true;
}

/** App access requires Support or Admin Entra group membership. */
export function hasAppAccess(persona: AuthMePersona | undefined): boolean {
  return isSupportPersona(persona) || isAdminPersona(persona);
}

export function canAccessAnalytics(persona: AuthMePersona | undefined): boolean {
  return persona?.canAccessAnalytics !== false;
}
